import type { CollapseProps } from 'antd';
import { Collapse, List, Skeleton } from 'antd';
import { useDepartmentsWithSupervisors } from '../../hooks/departmentHooks';

export const DepartmentsAndSupervisorsCollapse = () => {
  const { data: departmentsWithSupervisors, isLoading } =
    useDepartmentsWithSupervisors();

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 6 }} />;
  }

  const items: CollapseProps['items'] = departmentsWithSupervisors?.map(
    (x) => ({
      key: x.departmentName,
      label: x.departmentName,
      children: (
        <List
          size="small"
          dataSource={x.supervisorNames}
          renderItem={(item) => <List.Item>{item}</List.Item>}
        />
      ),
    })
  );

  const allKeys = departmentsWithSupervisors?.map((dep) => dep.departmentName);

  return <Collapse items={items} defaultActiveKey={allKeys} />;
};
